import React from 'react';
import GenericModal from '../../../components/modal/GenericModal';

// Confirmación antes de "Eliminar" en EntrevistaPostulante.jsx: la entrevista
// deja de estar disponible para la postulación (borrado lógico, EstadoRegistro
// = 2). No se puede deshacer desde la interfaz, así que conviene un paso de
// confirmación. Mismo patrón que ConfirmarGuardarNotificarModal.
// `mensaje` es opcional: una entrevista ya evaluada (Apto/No apto) lo usa para
// avisar que deja de contar para la decisión de la etapa.
const ConfirmarEliminarEntrevistaModal = ({
    toggleModal,
    onContinue,
    mensaje = 'Se eliminará la entrevista seleccionada. ¿Desea continuar?',
}) => {
    const handleContinue = () => {
        onContinue();
        toggleModal();
    };

    return (
        <GenericModal showModal={toggleModal} titulo="Confirmar" width="480px">
            <div className="modal-body pt-0">
                <p className="mb-0">{mensaje}</p>
            </div>
            <div className="modal-footer justify-content-end">
                <button
                    type="button"
                    className="btn btn-outline-primary generic-button-ficha-outlined"
                    onClick={toggleModal}
                >
                    Cancelar
                </button>
                <button
                    type="button"
                    className="btn btn-danger generic-button-ficha mr-2"
                    onClick={handleContinue}
                >
                    Eliminar
                </button>
            </div>
        </GenericModal>
    );
};

export default ConfirmarEliminarEntrevistaModal;
